






































































import { Component, PropSync, Vue } from 'vue-property-decorator';

import FlagshipProfilingSowosPocketViewModel
  from '@/vue-app/view-models/components/flagship/flagship-profiling/flagship-profiling-sowos-pocket-view-model';

@Component({
  name: 'FlagshipProfilingSowosPocket',
  components: {
    FlagshipProfilingExitPoll: () => import('@/vue-app/components/flagship/flagship-profiling/FlagshipProfilingExitPoll.vue'),
  },
})
export default class FlagshipProfilingSowosPocket extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  synced_is_open!: boolean;

  flagship_pocket_view_model = Vue.observable(
    new FlagshipProfilingSowosPocketViewModel(),
  );

  showContractSavingsModal() {
    this.$emit('hideRecommended');
    this.$emit('contractPocket');
    this.synced_is_open = false;
  }

  updateInformation() {
    this.$emit('hideRecommended');
    this.flagship_pocket_view_model.updateInformation();
  }

  closeModal() {
    this.synced_is_open = false;
    this.flagship_pocket_view_model.showPollModal();
    this.$emit('hideRecommended');
  }
}
